"use client";
import { cn } from '@/lib/utils';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import Image from 'next/image';
import React, { useState } from 'react'

const InternationalCollaboration = () => {

    const [index, setIndex] = useState<number>(0)

    const QUOTES = [
        {
            name: "AWS Student Certification Program",
            description: "The AWS Student Certification Program is a global initiative by Amazon Web Services to help students build cloud computing skills and earn industry-recognized certifications for free. Through the AWS Educate platform, students access self-paced training, hands-on labs, and certification vouchers for foundational and associate-level exams. \nPCPS supports this program to empower students with practical cloud expertise, enhance employability, and connect them to real-world tech opportunities.",
            image: '/collab/aws.jpeg',
            // position: 'Chairman LBEF Group of Institute'
        },
        {
            name: "Programiz Pro",
            description: "ProgramIsPro is a leading online learning platform offering expert-led courses in programming, software development, and technology skills. Focused on practical, project-based learning, it helps students and professionals upskill efficiently and stay industry-ready. PCPS collaborates with ProgramIsPro to provide students with access to quality tech education, hands-on projects, and career advancement resources.",
            image: '/collab/programiz_pro.jpg',
            // position: 'Executive Director'
        }
    ]

    return (
        <section
            className={cn(
                "mt-[25px]",
                // MOBILE: px-5  DESKTOP: px-[52px] px-[50px]
                "px-5 md:px-[3.1875rem] md:pr-[3.125rem]",
                "w-full"
            )}
        >
            <div
                className={cn(
                    "max-w-[870px] mx-auto", // lock max width on large screens and center it horizontally
                )}
            >
                <h2
                    className={cn(
                        `xl:box-content xl:text-[1.75rem] xl:leading-[2.5rem] xl:px-0`,
                        `md:max-w-[43.125rem] md:box-border
                    md:w-full md:text-[1.25rem] md:leading-[2.1875rem] md:mb-[1rem] md:clear-none md:px-0`,
                        `[word-wrap:break-word;] `,
                        `text-[1.15rem] leading-[1.6875rem] mt-0 mb-[0.375rem] clear-both font-bold`,
                        // REMOVE previous px or mx-auto: 
                        // On mobile this will inherit the px-5 above by default
                    )}
                >
                    International Collaboration
                </h2>

                <div className={cn(
                    `w-full mt-9`
                )}>

                    <div className={cn(
                        `md:mb-[70px] md:max-w-[870px] w-full`,
                        `overflow-hidden m-[0_auto_45px]`
                    )}>
                        <div id='container'>
                            {
                                QUOTES.map((quote, idx) => {
                                    return <div
                                        key={quote.name.toLocaleLowerCase()}
                                        className={cn(
                                            `xl:min-w-[870px] md:border-b md:border-b-[#939393] md:min-w-[668px] md:flex-col md:justify-between min-w-[280px] overflow-hidden pb-[40px]`,
                                            {
                                                'md:flex': idx === index,
                                                'hidden': idx !== index
                                            }
                                        )}
                                    >
                                        <div className={cn(
                                            `md:self-center`
                                        )}>
                                            <div
                                                className={cn(
                                                    "mt-[21px] flex justify-center",
                                                    `sm:float-none`,
                                                    "md:mt-0 md:justify-end",
                                                    "md:float-right md:pl-[32px]",
                                                    "xl:mt-[40px] xl:pl-[40px]"
                                                )}
                                            >
                                                <Image
                                                    alt={quote.name}
                                                    src={quote.image}
                                                    width={230}
                                                    height={230}
                                                    sizes="
                                                        (max-width: 767px) 115px,
                                                        (max-width: 1209px) 164px,
                                                        230px
                                                    "
                                                    className={cn(
                                                        "object-contain object-top block",
                                                        "w-[115px] h-[115px]",
                                                        "md:w-[164px] md:h-[164px]",
                                                        "xl:w-[230px] xl:h-[230px]"
                                                    )}
                                                />
                                            </div>

                                            <blockquote
                                                className={cn(
                                                    "md:text-base md:leading-8 md:block",
                                                    "text-[0.875rem] not-italic leading-[1.75rem] m-[0_0_21px]"
                                                )}
                                            >
                                                {quote.description.split("\n").map((line, i) => (
                                                    <p key={i}>{line}</p>
                                                ))}
                                            </blockquote>

                                            <span className={cn(
                                                `md:text-base md:leading-[24px] md:block `,
                                                `text-sm leading-[21px]`
                                            )}>
                                                <span className={cn(`font-bold`)}>
                                                    {quote.name}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                })
                            }
                        </div>

                        <div
                            className={cn(
                                `md:border-t md:border-t-[#939393]`
                            )}
                        >
                            <div className={cn(
                                `md:w-[170px]`,
                                `bg-white gap-x-[17px] flex text-base [justify-content:left] leading-[16px] relative top-[-10px]`
                            )}>
                                <button
                                    className={cn(
                                        `bg-none cursor-pointer border-none`,
                                        `before:content-[url("/svgs/longarrowleft-red.svg")]`
                                    )}
                                    onClick={() => {
                                        setIndex(pre => Math.max(pre - 1, 0))
                                    }}
                                    disabled={index === 0}
                                    aria-label="Previous leader"
                                />
                                <div className={cn(
                                    `m-[0_-14px_0_-10px]`
                                )}>
                                    <span className={cn(
                                        `font-bold inline-block m-[0_2px]`
                                    )}>{index + 1}</span>
                                    /
                                    <span className={cn(
                                        `inline-block m-[0_2px]`
                                    )}>{QUOTES.length}</span>
                                </div>

                                <button
                                    className={cn(
                                        `bg-none cursor-pointer border-none`,
                                        `before:content-[url("/svgs/longarrowright-red.svg")]`
                                    )}
                                    onClick={() => {
                                        setIndex(pre => Math.min(pre + 1, QUOTES.length - 1))
                                    }}
                                    disabled={index === QUOTES.length - 1}
                                    aria-label="Next"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default InternationalCollaboration;